@import (reference) '../../constants/spacing.module.less';

.pageContainer {
  padding: @space-32;
  background: var(--grey-100);
  min-height: 100%;
  height: 100%;
  overflow-y: auto;
}

.contentContainer {
  max-width: 1000px;
  margin: @space-40 auto;
}

.subCopy {
  color: var(--grey-600);
}

.productGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: @space-12;
}

.exploreMoreGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: @space-12;
}

.imageContainer {
  position: relative;
  width: 100%;
}

.exploreImageWrapper {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(0deg, rgba(15, 15, 16, 0.7) 0%, rgba(15, 15, 16, 0.7) 100%);
    border-radius: 8px;
  }
}

.imageLabel {
  position: relative;
  z-index: 1;
  color: var(--white);
  text-align: center;
}

.exploreImageWrapper button {
  position: relative;
  z-index: 1;
}
